import React from 'react';
import { HomeSectionProps } from './HomeSectionProps';

const licenseData = [
    {
        image: 'kpbpa.png',
        title: '2025시즌 선수협 공식 라이선스 취득',
        text: '플레이볼 판타지는 한국프로야구선수협회 공식 라이선스 파트너입니다.',
    },
    {
        image: 'yeonhap.jpeg',
        title: '연합뉴스와 기사 사용 제휴',
        text: '연합뉴스 최신 KBO 기사, 이제 플레이볼에서 바로 확인하세요!',
    },
];

const License: React.FC<HomeSectionProps> = ({ className }) => {
    return (
        <section id="license" className={`py-5 keep-all ${className ?? ''}`}>
            <div className="container py-5">
                <div className="text-center mb-5">
                    <span className="badge rounded-pill text-bg-info bg-opacity-75 mb-3">공식 라이선스</span>
                    <h2 className="fw-bold">신뢰할 수 있는 파트너와 함께합니다</h2>
                    <p className="lead text-muted mx-auto" style={{ maxWidth: '700px' }}>
                        플레이볼 판타지는 공신력 있는 기관과의 협력을 통해 더욱 신뢰도 높은 서비스를 제공합니다.
                    </p>
                </div>
                <div className="row g-4 justify-content-center">
                    {licenseData.map((item, index) => (
                        <div key={index} className="col-lg-4 col-md-6">
                            <div className="card shadow-sm h-100 text-center border-0">
                                <div className="card-body p-4">
                                    <div className="d-inline-flex align-items-center justify-content-center rounded-3 text-white mb-3" style={{ width: 'auto', height: '80px' }}>
                                        <img src={item.image} alt={item.title} style={{ maxHeight: '100%', maxWidth: '100%' }} />
                                    </div>
                                    <h3 className="h5 fw-semibold">{item.title}</h3>
                                    <p className="text-muted small">{item.text}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default License;